export default __webpack_public_path__ + "static/media/scales_grey.a50286cc.svg";